/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerType = {
  INDIVIDUAL: 'INDIVIDUAL',
  GROUP: 'GROUP',
  BUSINESS: 'BUSINESS',
} as const;
